<template>
  <a-form :form="form" @submit="handleSubmit">
    <a-form-item label="Financial institution">
      <a-select
        show-search
        option-filter-prop="children"
        v-decorator="[
          'institutionId',
          {
            rules: [
              {
                required: true,
                message: 'Please select a financial institution',
              },
            ],
          },
        ]"
      >
        <a-select-option
          v-for="institution in financialInstitutions"
          :key="institution.id"
          :value="institution.id"
        >
          {{ institution.name }}
        </a-select-option>
      </a-select>
    </a-form-item>
    <a-form-item>
      <a-button type="primary" html-type="submit" :disabled="submitting">
        Add
      </a-button>
    </a-form-item>
  </a-form>
</template>

<script>
import gql from 'graphql-tag'

export default {
  props: {
    index: {
      type: String,
      required: true,
    },
  },
  apollo: {
    financialInstitutions: {
      client: 'kpis',
      query: gql`
        query {
          financialInstitutions {
            id
            name
            currency
          }
        }
      `,
    },
  },
  data() {
    return {
      financialInstitutions: [],
      form: this.$form.createForm(this),
      submitting: false,
    }
  },
  methods: {
    clearForm() {
      this.form.getForm().resetFields()
    },
    async addConstituent({ institutionId, institutionName, currency }) {
      const response = await this.$apollo.mutate({
        mutation: gql`
          mutation($input: AddFinancialInstitutionConstituentInput) {
            addFinancialInstitutionConstituent(input: $input) {
              financialInstitution {
                key
                name
                currency
              }
            }
          }
        `,
        variables: {
          input: {
            institutionId: institutionId,
            institutionName: institutionName,
            currency: currency,
            index: this.index,
          },
        },
      })
      return response.data.addFinancialInstitutionConstituent.institution
    },
    async handleSubmit(e) {
      e.preventDefault()
      this.form.validateFields(async (err, values) => {
        {
          if (!err) {
            this.submitting = true
            const selectedInstitution = this.financialInstitutions.find(
              (i) => i.id === values.institutionId,
            )
            try {
              const constituent = await this.addConstituent({
                institutionId: selectedInstitution.id,
                institutionName: selectedInstitution.name,
                currency: selectedInstitution.currency,
              })
              this.clearForm()
              this.$emit('constituentAdded', constituent)
              this.submitting = false
            } catch (error) {
              console.log(error)
              this.$message.error('Adding constituent failed!')
              this.submitting = false
            }
          }
        }
      })
    },
  },
}
</script>

<style></style>
